import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { useContext, useEffect, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
// Secretary General Email
export default function PoliticalPartyRequirements({ isSecretary_General_Email = false, setSecretaryGeneralEmail = () => { } }) {
	var { selectedParty, contestationPeriodID } = useContext(PoliticalPartyDBContext);

	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(true);
	var [__rules, __setRules] = useState([]);

	var political = new PoliticalPartyService();

	function renderColumnRule(row) {
		return (
			<div className="flex  align-items-center">
				<>
					{row !== null && (
						<>
							{!row?.processed ? (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="p-button-secondary p-button-rounded   p-button p-component p-button-icon-only pi pi-exclamation-triangle"
								></i>
							) : row?.broken ? (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="p-button-danger p-button-rounded   p-button p-component p-button-icon-only pi pi-times"
								></i>
							) : (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="pi pi-check  p-button-success p-button-rounded p-button p-component p-button-icon-only"
								></i>
							)}
							<b className="ml-3">{row?.name || ""}</b>
						</>
					)}
				</>
			</div>
		);
	}


	useEffect(() => {

		if (selectedParty !== null) {
			setLoading(true);
			political.getPartyRequirements(selectedParty.politicalPartyID, contestationPeriodID).then((res) => {
				__setRules(res);
				res.forEach(req => {
					if (req.partyRuleID === 6 && req.broken === false) {
						setSecretaryGeneralEmail(true);
					}
				});
				setLoading(false);
			});
		}

	}, [refresh, selectedParty]);



	return (
		<>
			{isSecretary_General_Email === false && (<>
				<DataTable
					className={`remove-border ${__rules.length > 0 && ('remove-display-message')} `}
					header={"Requirements"}
					size="small"
					scrollable={true}
					dataKey="id"
					loading={loading}
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage={"No requirements"}



				>
				</DataTable>
				<div className="grid mt-2">
					{__rules.map((e, i) => <div key={i} className="col-12 md:col-6 lg:col-4">
						{renderColumnRule(e)}
						<hr />
					</div>)}

				</div>
			</>)}


		</>
	);
}
